module.exports = __webpack_public_path__ + "2dd7f35778356dcf31580a4cb2c1f435.png";